import React from 'react'
import classNames from 'classnames'

import { LentaLogo } from '@app/components'

import styles from './styles.module.scss'

import type { MainSideMenuHeaderProps } from './types'

export const SideMenuHeader: React.FC<MainSideMenuHeaderProps> = ({ isCollapse, className }) => {
  const rootClassName = classNames(
    styles.sideMenuHeader,
    {
      [styles.sideMenuHeader_collapse]: isCollapse
    },
    className
  )

  return (
    <header className={ rootClassName }>
      <LentaLogo hideText={ isCollapse } />
    </header>
  )
}
